import styled from 'styled-components';

export const PickupCalendarContainer = styled.div`
  border-radius: 4px;
  padding: 1rem 0.5rem;
  color: ${(props) => {
    if (props.disabled) return '#cccccc';
    return 'inherit';
  }};
  background: ${(props) => {
    if (props.disabled) return '#f6f6f6';
    return 'transparent';
  }};
  box-shadow: ${(props) => {
    if (props.disabled) return 'none';
    if (props.selected) return `inset 0 0 0 2px ${props.ctaColor}`;
    return 'inset 0 0 0 1px #CCCCCC';
  }};
  :hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    box-shadow: ${(props) => {
      if (props.disabled) return 'none';
      if (props.selected) return `inset 0 0 0 2px ${props.ctaColor}`;
      return `inset 0 0 0 1px ${props.ctaColor}`;
    }};
  }
  margin: 0.5rem;
`;
